import Masonry from 'masonry-layout';

import Component from '../component';

export default class TileList extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);
    this.opts = opts;

    this.bindEvents();
  }

  bindEvents() {
    this.masonry = new Masonry(this.$element[0], this.opts);
  }

  unbindEvents() {
    this.masonry.destroy();
  }

  reload() {
    setTimeout(() => {
      this.masonry.layout();
    }, 0);
  }
}
